import { Controller } from "@hotwired/stimulus"

// Przyciski Play w menu w trakcie pracy (organize/workinfos/_menu_buttons): najpierw główny przycisk to || (przerwa),
// a Zakończ pracę jest w rozwijanej liście. Po Organize::WorkdayLog::STOP_FIRST_AFTER dzisiejszej pracy
// (switchInValue sekund od wyrenderowania) zamieniamy warianty - główny staje się Zakończ pracę, a przerwa idzie do listy.
export default class extends Controller {
  static targets = ["pauseFirst", "stopFirst"]
  static values = { switchIn: Number }

  connect() {
    if (this.switchInValue > 0) {
      this.timer = setTimeout(() => this.showStopFirst(), this.switchInValue * 1000)
    }
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  showStopFirst() {
    if (!this.hasPauseFirstTarget || !this.hasStopFirstTarget) return
    this.pauseFirstTarget.classList.replace("inline-flex", "hidden")
    this.stopFirstTarget.classList.replace("hidden", "inline-flex")
  }
}
